import * as CONSTS from 'redux/constants';

export const updateSupportedDigitalWalletProvider = ({ providerName }) => ({
  type: CONSTS.UPDATE_SUPPORTED_DIGITAL_PROVIDER,
  payload: { providerName }
});
